import styled, {css} from 'styled-components'

export const StyledDetailsHeader = styled.div(
    ({theme: {spacing, typography, palette}}) => css`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: ${spacing * 2}px;
        padding: ${spacing * 4.5}px;

        & h1 {
            ${typography.textLg};
            font-weight: 500;
        }
        & h2 {
            ${typography.textSm};
            color: ${palette.neutral['500']};
        }
    `
)
